import { QUERY_KEYS, soCaiColumns, theKhoColumns } from '@/constants';
import { InfoDropdown } from '@/components/custom/erp';

const PhieuNhapKhoInfoDropdown = ({ uuid, ma_ct }: { uuid: string; ma_ct?: string }) => (
  <InfoDropdown
    uuid={uuid}
    ma_ct={ma_ct}
    tableItems={[
      {
        title: 'Xem sổ kho mua/bán hàng',
        endpoint: QUERY_KEYS.SO_KHO,
        columns: theKhoColumns,
        group: 1,
        visibleFields: [
          'loai_kho',
          'xid',
          'ma_unit',
          'so_ct',
          'ngay_ct',
          'ma_kho',
          'ma_vt',
          'ten_vt',
          'ma_kh',
          'ma_nt',
          'px_dd',
          'pn_tb',
          'gia',
          'sl_nhap',
          'tien_nhap',
          'thue',
          'ma_bp',
          'ma_vv',
          'ma_hd',
          'ma_dtt',
          'ma_ku',
          'ma_phi',
          'ma_lsx',
          'ma_ct'
        ]
      },
      {
        title: 'Xem sổ cái',
        endpoint: QUERY_KEYS.SO_CAI,
        columns: soCaiColumns,
        group: 1
      }
    ]}
  />
);

export default PhieuNhapKhoInfoDropdown;
